import { createSlice } from '@reduxjs/toolkit';

import actions from './cart_product_editor.actions';

type SliceInitialState = {
  edit?: {
    id: number;
    status: 'setup' | 'ready';
  };
};

const initialState: SliceInitialState = {};

const slice = createSlice({
  name: 'cart_product_editor',
  initialState,
  reducers: {
    resetEditStatus(state) {
      return { ...state, edit: undefined };
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(actions.pending, (state, { payload }) => {
        return { ...state, edit: { id: payload, status: 'setup' } };
      })
      .addCase(actions.setupComplete, (state) => {
        const { edit } = state;
        if (!edit) throw new Error('Setup failed');

        return { ...state, edit: { ...edit, status: 'ready' } };
      }),
});

export default slice;
